import React from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form, Button } from 'react-bootstrap';
import { Input, DateTimeInput, FormActions, Checkbox, HtmlEditor } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import Localizations from '../localization';
import ui from '../../common/services/ui';
import CentersDropdownList from '../centers/DropdownList';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, initialValues, submitSucceeded, termTypes, schoolYears, allowOverlappingTerms, isRestrictedUser, t }) => {
	let id = initialValues ? initialValues.id : 0;

	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
			<Field name='name' component={Input} disabled={isReadonly} horizontal required type='text' label={t('Term_Name')} validate={validators.required} />
			{id > 0 && <Localizations entityId={id} rootName={'terms'} propertyName={'Name'} label={t('Term_Name')} resourceName={`Term.${id}.Name`} isHtml={false} isReadonly={isReadonly} />}
			<CentersDropdownList render='field' name='centerId' disabled={isReadonly} horizontal label={t('Common_Center')} emptyLabel={isRestrictedUser ? '' : t('Common_AllCenters')} />
			<Field name='themeDescription' component={HtmlEditor} disabled={isReadonly} horizontal type='text' label={t('Term_ThemeDescription')} />
			{id > 0 && <Localizations entityId={id} rootName={'terms'} propertyName={'ThemeDescription'} label={t('Term_ThemeDescription')} resourceName={`Term.${id}.ThemeDescription`} isHtml={true} isReadonly={isReadonly} />}
			<Field name='schoolYearId' component={Input} componentClass='select' horizontal required label={t('Term_SchoolYear')} validate={validators.required}>
				<option />
				{ui.makeOptionValues(schoolYears)}
			</Field>
			<Field name='type' component={Input} componentClass='select' horizontal required={!allowOverlappingTerms} label={t('Term_Type')} validate={!allowOverlappingTerms && validators.required}>
				<option />
				{ui.makeOptionValues(termTypes)}
			</Field>
			<Field name='startDate' component={DateTimeInput} disabled={isReadonly} horizontal required showTime={false} label={t('Term_StartDate')} validate={[validators.required]} />
			<Field name='endDate' component={DateTimeInput} disabled={isReadonly} horizontal required showTime={false} label={t('Term_EndDate')} validate={[validators.required]} />
			<Field name='allowBooking' component={Checkbox} disabled={isReadonly} horizontal label={t('Term_AllowBooking')} normalize={(v) => { return !!v }} />
			<FormActions horizontal>
				<Link to='/terms' className='btn btn-default'>{t('Common_BackToList')}</Link>
				<Button type='submit' disabled={isReadonly || pristine || submitting} bsStyle='primary'>{t('Common_Save')}</Button>
			</FormActions>
		</Form>
	);
};

export default reduxForm({ form: 'term', enableReinitialize: true })(withTranslation()(SettingsForm));
